import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../components/admin/Table";
import { UserManageService } from "../../services/UserManageService";

const userManageService = new UserManageService();

export default function Users() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allUsersActive, setAllUsersActive] = useState(false);

  const fetchUsers = () => {
    setLoading(true);
    userManageService
      .find({ itemsPerPage: 300, active: "all", pagination: false })
      .then((response) => {
        const userList = response.items.map((item) => ({
          ...item,
          fullName: `${item.name} ${item.surname || " "} ${
            item.lastName || " "
          }`
            .trim()
            .replace(/\s{2,}/g, " "),
        }));
        setUsers(userList);
        // Check if all users are active
        setAllUsersActive(userList.every((user) => user.active));
      })
      .catch((error) => {
        console.error("Erro ao buscar usuários:", error);
        alert("Não foi possível carregar os usuários.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const toggleAllUsersStatus = async () => {
    try {
      const newStatus = !allUsersActive;
      await userManageService.toggleAllUsersStatus(newStatus);
      setAllUsersActive(newStatus);
      fetchUsers();
    } catch (error) {
      console.error("Erro ao alterar status dos usuários:", error);
      alert("Não foi possível alterar o status dos usuários.");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const toggleUserStatus = async (user) => {
    try {
      console.log("user", user);
      if (user.active) {
        console.log("disabling");
        await userManageService.disable(user._id);
      } else {
        console.log("enabling");
        await userManageService.enable(user._id);
      }
      fetchUsers();
    } catch (error) {
      console.error("Erro ao alterar status do usuário:", error);
      alert("Não foi possível alterar o status do usuário.");
    }
  };

  function renderSwitch(user) {
    return (
      <div className="form-check form-switch text-center">
        <input
          className="form-check-input"
          type="checkbox"
          checked={user.active}
          onChange={() => toggleUserStatus(user)}
        />
      </div>
    );
  }

  const columns = [
    {
      label: "Ativo",
      field: "active",
      render: renderSwitch,
    },
    { label: "Nome", field: "fullName" },
    { label: "Matrícula/Usuário", field: "username" },
  ];

  const onAdd = () => navigate("/admin/users/new");
  const onEdit = (user) => navigate(`/admin/users/${user._id}`);
  const onDelete = (user) => {
    if (
      window.confirm(
        `Tem certeza de que deseja excluir o usuário "${user.name}"?`
      )
    ) {
      userManageService
        .delete(user._id)
        .then(() => {
          alert("Usuário excluído com sucesso!");
          fetchUsers();
        })
        .catch((error) => {
          console.error("Erro ao excluir usuário:", error);
          alert("Não foi possível excluir o usuário.");
        });
    }
  };

  if (loading) {
    return <div className="text-center mt-5">Carregando usuários...</div>;
  }

  return (
    <div>
      <div className="container pt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Usuários</h2>

          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              checked={allUsersActive}
              onChange={toggleAllUsersStatus}
            />
            <label className="form-check-label">
              {allUsersActive ? "Todos Ativos" : "Todos Inativos"}
            </label>
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        data={users}
        onAdd={onAdd}
        onEdit={onEdit}
        onDelete={onDelete}
        className="mt-5"
      />
    </div>
  );
}
